module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-width": "130px",
      "model": _vm.combinationData,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组合筛选功能"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combinationData.is_open),
      expression: "combinationData.is_open"
    }],
    domProps: {
      "value": (_vm.combinationData.is_open)
    },
    on: {
      "input": function($event) {
        _vm.combinationData.is_open = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("开启")])])]), _vm._v(" "), (_vm.combinationData.is_open === 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "字段",
      "prop": "filter_field_ids"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combinationData.filter_field_ids),
      expression: "combinationData.filter_field_ids"
    }],
    staticClass: "w-200",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.combinationData.filter_field_ids)
    },
    on: {
      "input": function($event) {
        _vm.combinationData.filter_field_ids = $event
      }
    }
  }, _vm._l((_vm.fields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.field + item.title,
        "value": item.field_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.field) + _vm._s(item.title))])])
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许使用绑定权限"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.use_auth),
      expression: "use_auth"
    }],
    staticClass: "h-40 fl w-200 m-r-10",
    domProps: {
      "value": (_vm.use_auth)
    },
    on: {
      "input": function($event) {
        _vm.use_auth = $event
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "m-l-10",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.openUseRultList()
      }
    }
  }, [_vm._v("查找")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许配置绑定权限"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.build_auth),
      expression: "build_auth"
    }],
    staticClass: "h-40 fl w-200 m-r-10",
    domProps: {
      "value": (_vm.build_auth)
    },
    on: {
      "input": function($event) {
        _vm.build_auth = $event
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "m-l-10",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.openBuildRultList()
      }
    }
  }, [_vm._v("查找")])])]) : _vm._e()]), _vm._v(" "), _vm._v(" "), _c('rule-list', {
    ref: "useRuleList",
    attrs: {
      "title": _vm.title
    },
    on: {
      "selectRule": _vm.selectUseRule
    }
  }), _vm._v(" "), _c('rule-list', {
    ref: "buildRuleList",
    attrs: {
      "title": _vm.title
    },
    on: {
      "selectRule": _vm.selectBuildRule
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-272d593f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/combinationConfig.vue
// module id = 1796
// module chunks = 2